export default {"src":"/_next/static/media/icon-chat.a5148b33.svg","height":1600,"width":1600};